import { stripHtmlTags } from 'core/utils';
import { QuoteNoteType } from 'quotes/enums';
import { ICustomerQuote, IQuoteNoteForm } from 'quotes/types';
import { getQuoteNoteContent, getQuoteNoteId } from 'quotes/utils';

export const mapQuoteNoteToForm = (quote: ICustomerQuote, type: QuoteNoteType): IQuoteNoteForm => ({
  content: getQuoteNoteContent(quote, type),
});

export const mapUpsertQuoteNoteForm = (
  data: IQuoteNoteForm,
  quote: ICustomerQuote,
  type: QuoteNoteType
) => ({
  quoteNote: {
    content: stripHtmlTags(data.content).length > 0 ? data.content : null,
    quoteId: quote.id,
    id: getQuoteNoteId(quote, type),
    type,
  },
});
